export default "__VITE_ASSET___yy6DW6I__"